// Google Drive Portfolio Images - 27 total images

const allGalleryImages = [
  { id: '1n39ogCnaOGBkJIEk9m3F0V5tARoOim4g', caption: 'Document Translation', filename: 'IMG_1808.PNG' },
  { id: '1ASZS_2bGCAfETySS3-64NoiR2IdDrbQs', caption: 'Drama Subtitles', filename: 'IMG_1809.PNG' },
  { id: '1xe4F91d-jqiH4MjJU0OT7giq4xOuk70E', caption: 'Commercial Translation', filename: 'IMG_1810.PNG' },
  { id: '1esdhZjD5hNMJX2Q-HaPWq-7Nyrg_cup1', caption: 'Song Translation', filename: 'IMG_1811.PNG' },
  { id: '1eYdvEJq1ppqOYaZpYLlCsAxQlgXl4hzB', caption: 'Social Media Content', filename: 'IMG_1812.PNG' },
  { id: '1DXqKimQOneyAuc6c3KcL3DLTi7uttt4h', caption: 'Voiceover Script', filename: 'IMG_1813.PNG' },
  { id: '1wiVy7CJA2Lt4YVufErxQFHWu3Snbcobm', caption: 'K-Idol Commercial', filename: 'IMG_1814.PNG' },
  { id: '1CW-XbyaJtX3HGS8odSZwoVLuMvcrQ0NM', caption: 'YouTube Subtitles', filename: 'IMG_1815.PNG' },
  { id: '1TJuLGLZyEGfaP-tvjJPPPu-ovIw47VHC', caption: 'Brochure Translation', filename: 'IMG_1816.PNG' },
  { id: '1QEudHeitJyhgfYQ_slCp1c9Recz2dmHs', caption: 'Product Description', filename: 'IMG_1817.PNG' },
  { id: '1gs4P4aR8gFXGiVK6RWiIa_H_PYmyXKAf', caption: 'Drama Translation', filename: 'IMG_1818.PNG' },
  { id: '1Fo-iwQMTq0t4CkpupwhVY_DQPn9OM9N5', caption: 'Commercial Content', filename: 'IMG_1819.PNG' },
  { id: '1yy90Xih7-8AaGXO6lVE6zh2MICalo_aw', caption: 'Legal Document', filename: 'IMG_1820.PNG' },
  { id: '1N9cVFIjkAQh5XJnv9Sl-2GI8LHcSJY4E', caption: 'Marketing Material', filename: 'IMG_1821.PNG' },
  { id: '1WctVpkvHDpqvV1A0Y6ukt75q5OXxqSUJ', caption: 'Song Lyrics', filename: 'IMG_1822.PNG' },
  { id: '11hXdgp2o0rrvnSj8r2QQQb-NJU4spmT8', caption: 'Social Media Post', filename: 'IMG_1823.PNG' },
  { id: '1PAHj9GKP_iYySmrZKL-h6lECgWwxrSo8', caption: 'Entertainment Content', filename: 'IMG_1824.PNG' },
  { id: '1AXmp3wIuwOwdM1eAqYGgDm-L9TrDfItY', caption: 'Website Content', filename: 'IMG_1825.PNG' },
  { id: '1hor6-MAHCC06LrR6hzXEDB1_cqpTXZye', caption: 'Corporate Translation', filename: 'IMG_1841.PNG' },
  { id: '1kXWvxBAeeh7ktUvDNe3rljiwqlD_zq2g', caption: 'Media Content', filename: 'IMG_1842.PNG' },
  { id: '1NafrPk9TNdTpzTC3vOhOZrQ3ob450GGn', caption: 'Creative Translation', filename: 'IMG_1843.PNG' },
  { id: '1wH6fImkxslFy4ozuMb6-DsFF8ccF1ntZ', caption: 'Technical Document', filename: 'IMG_1851.PNG' },
  { id: '1sR2qUOnBcrBg8He9zyYqt_OqVvsJ0K-B', caption: 'Business Content', filename: 'IMG_1852.PNG' },
  { id: '1y4KmHrHbfrbezX1kS60tTVDSbXJgUJdX', caption: 'Educational Material', filename: 'IMG_1853.PNG' },
  { id: '1cTL7mImSBfw73srDwrdeiMKTrEs_Kg-E', caption: 'Professional Document', filename: 'IMG_1855.PNG' },
  { id: '1B6datbDFw5ngwqz_9bXBl60uxqIz-wkn', caption: 'Portfolio Sample', filename: 'IMG_7269.jpg' },
  { id: '1-WYu5RZPGn1Xab9mtiOTaGBtgIIRT7jb', caption: 'Recent Work', filename: 'PHOTO-2024-02-18-22-24-27.jpg' }
];

// Helper function to generate image URL. Use a local proxy endpoint so
// images are served same-origin (this avoids Cross-Origin Resource Policy
// / COEP issues when embedding Google Drive files directly).
const getDriveImageUrl = (fileId) => {
  // Proxy will fetch from Google Drive server-side and stream back the image
  // Example usage in components: <img src={`/api/drive-proxy?id=${fileId}`} />
  return `/api/drive-proxy?id=${encodeURIComponent(fileId)}`;
};

// Function to get 6 random images from the full collection
const getRandomGalleryImages = (count = 6) => {
  const shuffled = [...allGalleryImages].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, count).map(image => ({
    ...image,
    url: getDriveImageUrl(image.id),
    alt: `${image.caption} - ${image.filename}`
  }));
};

// Export functions and data
export {
  allGalleryImages,
  getRandomGalleryImages,
  getDriveImageUrl
};

// Default export: 6 random images for the homepage
export default getRandomGalleryImages();